import { FormikContextType } from 'formik';

export const isDisable = (form: FormikContextType<unknown>) => {
    const data: any = form?.values;
    const price = (data?.variant?.price || data?.variant.prices) / 100;
    if (price < 10 || price > 250) {
        return true;
    }
    if (form.isValid && !form.dirty && form.submitCount === 0) {
        return true;
    } else if (!form.isValid && (form.dirty || form.submitCount > 0)) {
        return true;
    } else if (form.isValid && (form.dirty || form.submitCount > 0)) {
        return false;
    }
    return true;
};
